<template>
  <v-menu
    ref="menu"
    v-model="menu2"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="time"
        :label="label"
        prepend-inner-icon="access_time"
        readonly
        v-on="on"
        :rules="rules"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu2"
      v-model="time"
      :min="disablePrev ? new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''"
      :disabled="!valid"
      :required="required"
      format="24hr"
      @input="$emit('on:time-selected', time)"
      @click:minute="$refs.menu.save(time)"
    ></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'TimePicker',
  props: {
    disablePrev: {
      type: Boolean,
      default: false,
    },
    label: {},
    valid: {},
    required: { default: () => false },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    time: null,
    menu2: false,
    modal2: false,
  }),
};
</script>
